import React from 'react';

import { IconAdd, IconRemove } from '@tvg/fuse/icon/all';
import { Link } from '@tvg/fuse/link';
import styles from './ShowMoreOption.module.css';

type Props = {
  isExpanded: boolean;
  setIsExpanded: (arg: boolean) => void;
};

function ShowMoreOption(props: Props) {
  const { isExpanded, setIsExpanded } = props;

  return (
    <Link
      className={styles.link}
      isButton
      dataTestId="show-more-option"
      icon={isExpanded ? <IconRemove /> : <IconAdd />}
      iconRight
      size="medium"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      Show {isExpanded ? 'less' : 'more'}
    </Link>
  );
}

export default ShowMoreOption;
